import React from "react";
import { createTheme, ThemeProvider } from "@material-ui/core";
import settings from "configs/settings";

const Theme = ( props ) => {

    const theme = createTheme({
        palette : {
            primary : {
                main : settings.css.primary,
            },
            secondary : {
                main : settings.css.secondary,
            },
        },
        TextField : {
            background : "red",
        }
    });

    return(
        <ThemeProvider theme={theme}>
            {props.children}
        </ThemeProvider>
    )
}

export default Theme;